import { apiConfig } from "./apiConfig";

export const fileApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getFileList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
      }
    >({
      query: ({
        startKey,
        page_size,
        brand_id,
        family_id,
        model_id,
        template_id,
      }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}/file`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
        },
      }),
      providesTags: ["File"],
    }),

    createFile: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
        body: any;
      }
    >({
      query: ({ body, brand_id, family_id, model_id, template_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}/file`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["File"],
    }),

    getSingleFileDetails: builder.query<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
        file_id: string | null;
      }
    >({
      query: ({ brand_id, family_id, model_id, template_id, file_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}/file/${file_id}`,
      }),
    }),

    editFile: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
        file_id: string | null;
        body: any;
      }
    >({
      query: ({
        brand_id,
        body,
        family_id,
        model_id,
        template_id,
        file_id,
      }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}/file/${file_id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["File"],
    }),
  }),
});

export const {
  useLazyGetFileListQuery,
  useCreateFileMutation,
  useEditFileMutation,
  useLazyGetSingleFileDetailsQuery,
} = fileApi;
